import * as types from '../constants';

export function changeTitle(titleText, auxillaryText = null) {
  return {
    type: types.CHANGE_TITLE,
    payload: {
      titleText,
      auxillaryText,
    },
  };
}
